var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgWalmartSpark(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19.557 13.517c.872 0 1.589-.453 1.686-1.038l.86-9.728C22.103 1.79 20.978 1 19.561 1c-1.415 0-2.54.79-2.54 1.751l.859 9.728c.096.585.813 1.038 1.68 1.038h-.003M14.3 16.555c.437-.753.403-1.6-.056-1.976L6.248 8.97c-.831-.48-2.078.1-2.785 1.326-.71 1.224-.584 2.594.245 3.074l8.853 4.123c.554.205 1.308-.19 1.742-.943l-.003.005M24.82 16.55c.435.753 1.186 1.148 1.74.943l8.854-4.123c.834-.48.953-1.85.249-3.074-.71-1.227-1.96-1.806-2.789-1.326L24.88 14.58c-.458.375-.492 1.223-.057 1.976l-.003-.005M19.557 25.667c.872 0 1.589.45 1.686 1.035l.86 9.727c0 .963-1.125 1.752-2.542 1.752-1.415 0-2.54-.788-2.54-1.752l.859-9.727c.096-.585.813-1.035 1.68-1.035h-.003M24.82 22.63c.435-.754 1.186-1.146 1.74-.938l8.854 4.118c.834.482.953 1.853.249 3.08-.71 1.221-1.96 1.802-2.789 1.322L24.88 24.61c-.458-.38-.492-1.227-.057-1.98l-.003.001M14.3 22.63c.437.752.403 1.6-.056 1.98l-7.996 5.602c-.831.48-2.078-.1-2.785-1.323-.71-1.226-.584-2.597.245-3.079l8.853-4.118c.554-.208 1.308.184 1.742.939l-.003-.001",
    fill: "#FFCE4D"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWalmartSpark);
export default __webpack_public_path__ + "static/media/Walmart Spark.77b909d4334eedb2ce2bb4e014e1f9c6.svg";
export { ForwardRef as ReactComponent };